import { StatusType } from '../../../sp-types/statusType';
import React from 'react';

interface IStatusBoxProps {
  status: StatusType;
}
export const StatusBox: React.FC<IStatusBoxProps> = ({ status }) => (
  <div className={`flex flex-0 p-2 rounded-md text-lg  border-gray-400 border text-${statusDictionary[status].color}`}>
    {statusDictionary[status].text}
  </div>
);

const statusDictionary: Record<StatusType, { text: string; color: string }> = {
  pending: { text: 'Pending', color: 'status-pending' },
  completed: { text: 'Completed', color: 'green-300' },
  started: { text: 'Started', color: 'gray-450' },
  underwriting: { text: 'Waiting', color: 'blue-300' },
  modified: { text: 'Modifying', color: 'blue-300' },
};
